import { dispatchCustomEventGlobally } from 'www/utils'
import { CLUB_EVENTS } from 'www/constants'

function emitOpenCardInfo(clubData, userPhone) {
  dispatchCustomEventGlobally(CLUB_EVENTS.cardInfoOpen, { clubData, userPhone })
}

export default emitOpenCardInfo
